import React, { FC, useMemo, useState } from "react";
import Icon from "../Icon/index";
import { Trans, t } from "@helpers/translate";

interface ITourProps {
  type: "tour";
  title: string;
  country: string;
  city: string;
  url: string;
}

interface IBlogProps {
  type: "blog";
  title: string;
  country: string;
  city: string;
  url: string;
}

interface ISupplierProps {
  type: "supplier" | "author";
  displayName: string;
  country: string;
  url: string;
}

export const ShareButton: FC<ITourProps | IBlogProps | ISupplierProps> = (
  payload
) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const mountEmailData = useMemo(() => {
    if (payload.type === "tour") {
      return {
        subject: `Check out this ${payload.city} tour on GoWithGuide`,
        body: `I found this ${
          payload.city
        } tour on GoWithGuide and thought you'd love it: ${payload.title.replace(
          /&/g,
          "and"
        )} %0aHere is the link: ${payload.url}`, //%0a used to break line
      };
    }
    if (payload.type === "blog") {
      return {
        subject: `Check out this article about ${payload.country} on GoWithGuide`,
        body: `I found this article about ${payload.country} on GoWithGuide and thought you'd love it: ${payload.title} %0aHere is the link: ${payload.url}`, //%0a used to break line
      };
    }

    if (payload.type === "supplier") {
      return {
        subject: `Check out this ${payload.country} guide from GoWithGuide`,
        body: `I found this ${payload.country} guide from GoWithGuide and thought you'd love it: ${payload.displayName} %0aHere is the link: ${payload.url}`, //%0a used to break line
      };
    }

    if (payload.type === "author") {
      return {
        subject: `Check out this author ${payload.displayName} on GoWithGuide`,
        body: `I found this authors article on GoWithGuide and thought you'd love it.`, //%0a used to break line
      };
    }

    return {
      subject: "",
      body: "",
    };
  }, []);

  const mountSmsData = useMemo(() => {
    if (payload.type === "tour") {
      return {
        subject: "",
        body: `I found this ${payload.city} tour on GoWithGuide and thought you'd love it: ${payload.title} %0aHere is the link: ${payload.url}`, //%0a used to break line
      };
    }
    if (payload.type === "blog") {
      return {
        subject: "",
        body: `I found this article about ${payload.country} on GoWithGuide and thought you'd love it: ${payload.title} %0aHere is the link: ${payload.url}`, //%0a used to break line
      };
    }
    if (payload.type === "supplier") {
      return {
        subject: "",
        body: `Check out this ${payload.country} guide I found on GoWithGuide: ${payload.displayName} %0aHere is the link: ${payload.url}`, //%0a used to break line
      };
    }

    return {
      subject: "",
      body: "",
    };
  }, []);

  return (
    <div className="flex relative sharebtn bg-white rounded-xl z-10 border justify-center align-middle">
      <button className="flex flex-row items-center px-4 pt-2 pb-2 rounded-xl">
        <Icon icon="share" size="sm" className="text-gray-500" />
      </button>
      <div className="sharebtn-dropdown absolute right-0 top-8 hidden pt-1">
        <div className="p-2 bg-white z-10 rounded-xl mt-2 border shadow-md">
          <div>
            <button
              className="w-full"
              onClick={() => {
                navigator.clipboard.writeText(payload.url);
                setLinkCopied(true);

                setTimeout(() => {
                  setLinkCopied(false);
                }, 2000);
              }}
            >
              <div
                className={`flex flex-row items-center whitespace-nowrap px-2 py-2 hover:bg-gray-100 rounded-xl ${
                  linkCopied ? "text-green-600" : "text-gray-800"
                }`}
              >
                <Icon
                  icon="copy"
                  size="sm"
                  className={`mr-2 ${
                    linkCopied ? "text-green-600" : "text-gray-600"
                  }`}
                />
                {linkCopied ? (
                  <Trans id="share.copied">Copied!</Trans>
                ) : (
                  <Trans id="share.copy">Copy Link</Trans>
                )}
              </div>
            </button>
          </div>
          <div>
            <a
              title={t({
                id: "common.link.title",
                message: "GoWithGuide - Private Tours & Local Tour Guides",
              })}
              href={`mailto:?subject=${mountEmailData.subject}&body=${mountEmailData.body}`}
            >
              <div className="flex flex-row items-center whitespace-nowrap px-2 py-2 hover:bg-gray-100 rounded-xl">
                <Icon icon="email" size="sm" className="mr-2 text-gray-600" />

                <Trans id="share.email">Email</Trans>
              </div>
            </a>
          </div>
          <div className="md:hidden">
            <a
              title={t({
                id: "common.link.title",
                message: "GoWithGuide - Private Tours & Local Tour Guides",
              })}
              href={`sms:?&body=${mountSmsData.body}`}
            >
              <div className="flex flex-row items-center whitespace-nowrap px-2 py-2 hover:bg-gray-100 rounded-xl">
                <Icon icon="chat" size="sm" className="mr-2 text-gray-600" />

                <Trans id="share.text-message">Text Message</Trans>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
